import { useReducer } from 'react';
import { paginationReducer } from 'y4/reducers/paginationReducer';

const usePagination = (itemsHook, itemsPerPage = 12, currentPage = 1) => {
  //Load paginationReducer
  const [paginationState, dispatch] = useReducer(paginationReducer, {
    allItems: [],
    data: [],
    pageChunk: [],
    totalPage: 0,
    totalItems: 0,
    itemsPerPage: 0,
    currentPage: 1,
    itemsLoaded: false,
    canNextPage: false,
    canPreviousPage: false,
    from: 0,
    to: 0,
    filter: {},
    paginationArray: []
  });

  //Functions
  //==================================

  //First load
  const initItems = filter => {
    itemsHook.initItems(filter).then(({ items, itemsCount }) => {
      dispatch({
        type: 'INIT',
        payload: {
          filter,
          items,
          itemsCount,
          itemsPerPage,
          currentPage
        }
      });
    });
  };

  const goToPage = pageNo => {
    itemsHook.loadItems(paginationState.filter, pageNo).then(({ items }) => {
      dispatch({
        type: 'GO_TO_PAGE',
        payload: {
          pageNo,
          items
        }
      });
    });
  };

  const nextPage = () => {
    itemsHook
      .loadItems(paginationState.filter, paginationState.currentPage + 1)
      .then(({ items }) => {
        dispatch({
          type: 'NEXT_PAGE',
          payload: {
            items
          }
        });
      });
  };

  const prevPage = () => {
    itemsHook
      .loadItems(paginationState.filter, paginationState.currentPage - 1)
      .then(({ items }) => {
        dispatch({
          type: 'PREVIOUS_PAGE',
          payload: {
            items
          }
        });
      });
  };

  const setItemsPerPage = no => {
    dispatch({
      type: 'INIT',
      payload: {
        itemsPerPage: no,
        currentPage
      }
    });
  };

  return {
    paginationState,
    initItems, //load data first time
    nextPage,
    prevPage,
    goToPage,
    setItemsPerPage
  };
};

export default usePagination;
